import css from 'styled-jsx/css';
import { colors } from '../../themes';

export default css`
  .download_app_banner {
    background-color: ${colors.grayExtraLight};
    display: flex;
  }

  .download_app_banner a {
    text-decoration: none;
  }

  .download_app_banner .close {
    flex: 0;
    padding: 12px;
    line-height: 2.6;
  }

  .download_app_banner .icon {
    flex-grow: 0;
    margin-right: 12px;
  }

  .download_app_banner .text {
    margin: 4px 0;
    max-width: 100%;
    min-width: 0;
  }

  .download_app_banner .title {
    margin: 0;
    font-size: 0.9375em; /* 15/16 */
    font-weight: bold;
    color: ${colors.grayDark};
  }

  .download_app_banner .slogan {
    margin: 0;
    font-size: 0.75em;
    color: ${colors.grayDark};
  }

  .download_app_banner__block {
    flex-shrink: 1;
    flex-grow: 1;
    align-self: center;
    max-width: 100%;
    padding: 12px 0;
  }

  .download_app_banner .link {
    flex-grow: 0;
    flex-shrink: 0;
    padding-right: 12px;
  }

  .download_app_banner__text-line {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  :global(.rtl) .download_app_banner {
    flex-direction: row-reverse;
  }

  :global(.rtl) .download_app_banner .link {
    padding-left: 12px;
    padding-right: 0;
  }

  :global(.rtl) .download_app_banner .icon {
    margin-left: 12px;
    margin-right: 0;
  }

  @media (max-width: 360px) {
    .download_app_banner .close {
      padding: 12px 6px;
    }

    .download_app_banner .link {
      padding-right: 8px;
    }

    .download_app_banne .icon {
      margin-right: 8px;
    }

    .download_app_banner :global(button) {
      font-weight: normal !important;
      padding: 12px !important;
    }

    :global(.rtl) .download_app_banner .link {
      padding-left: 8px;
      padding-right: 0;
    }

    :global(.rtl) .download_app_banner .icon {
      margin-left: 8px;
      margin-right: 0;
    }
  }
`;



// WEBPACK FOOTER //
// ./app/DownloadAppBanner/TopBanner/styles.js